<template>
	<div :style="sms_style" v-if="!_gHlp.isEmpty(smsProfile.contact_no)" :class="ctn_class">
		<el-button type="primary" :class="btn_class"
			@click="showSms(smsProfile)">
			<svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 512 512">
				<path fill="currentColor"
					d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9-1.9 24.5-11.4 46.3-21.4 62.9-5.5 9.2-11.1 16.6-15.2 21.6-2.1 2.5-3.7 4.4-4.9 5.7-.6.6-1 1.1-1.3 1.4l-.3.3c-4.6 4.6-5.9 11.4-3.4 17.4 2.5 6 8.3 9.9 14.8 9.9 28.7 0 57.6-8.9 81.6-19.3 22.9-10 42.4-21.9 54.3-30.6 31.8 11.5 67 17.9 104.1 17.9zm-53.1-271.2c6.5-2.2 13.7.1 17.9 5.6l35.2 46.9 35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6S320 185.1 320 192v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-6.9 4.4-13 10.9-15.2zm173.1 38v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.2-.4-23.7-4.4-32.6-7.4-1.4-.5-2.7-.9-4-1.4-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7.6 3.3 1.1 4.9 1.6 9.1 3.1 15.6 5.3 22.6 5.5 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.4-17.7-14.7-17.7-29.4-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 10 .2 19.7 2.3 27.9 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9zm-272 0v.4c.1.1.6.8 2.2 1.7 3.9 2.3 9.6 4.1 18.3 6.8l.6.2c7.4 2.2 17.3 5.2 25.2 10.2 9.1 5.7 17.4 15.2 17.6 29.9.2 15-7.6 26-17.8 32.3-9.5 5.9-20.9 7.9-30.7 7.6-12.3-.4-24.2-4.5-33.2-7.6-1.3-.4-2.5-.8-3.6-1.2-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4.5 2.8.9 4.1 1.4 9.5 3.2 16.5 5.6 23.7 5.8 5.3.2 10-1 12.8-2.8 1.2-.8 1.8-1.5 2.1-2 .2-.4.6-1.2.6-2.7v-.2c0-.7 0-1.4-2.7-3.1-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6-9-5.3-17.7-14.6-17.8-29.3-.1-15.2 8.6-25.7 18.5-31.6 9.4-5.5 20.5-7.5 29.7-7.4 9.5.1 22.2 2.1 31.1 4.4 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4-4.9-.1-9.8 1.1-12.9 2.9-1.4.8-2.1 1.6-2.4 2-.2.3-.4.8-.4 1.9z" />
			</svg>
		</el-button>
	</div>
</template>

<script>
import { Badge, Button, Popover, Table, TableColumn } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { isEqual } from 'lodash'

export default {
	props: {
		profile: {
			type: Object
		},
		ctn_class: {
			type: String,
			default: 'p-1'
		},
		btn_class: {
			type: String,
			default: 'p-1'
		},
		sms_style: {
			type: String,
			default: 'padding-top:8px'
		}
	},
	components: {
		[Badge.name]: Badge,
		[Button.name]: Button,
		[Popover.name]: Popover,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			loading_btn: false,
			smsProfile: {
				owner_id:null,
				owner_type:null,
				contact_no:null,
			}
		}
	},
	watch: {
		profile: {
			handler(newVal, oldVal) {
				if (!isEqual(newVal, oldVal)) {
					this.setProfile(newVal)
				}
			},
			immediate: true,
		},
	},
	methods: {
		showSms(smsProfile) {
			chatEventBus.$emit('show-sms-drawer', smsProfile);
		},
		setProfile(data){
			this.smsProfile = {
				owner_id: _gHlp.getValue(data,'sas_im2u_id',_gHlp.getValue(data,'im2u_id',_gHlp.getValue(data,'id',null))),
				owner_type:'Customer',
				contact_no:_gHlp.getValue(data,'contact_no',null)
			}
		}
	}
}
</script>
